import { styled, Typography } from '@mui/material';

export const Page = styled('div')`
  min-height: 100vh;
  display: flex;
`;

export const PageContentW = styled('div')`
  background: ${({ theme }) => theme.palette.white.main};
  width: 50%;
  padding: 60px 120px 0 120px;
  background-color: #e9e9e9;

  @media (min-width: 1023px) {
    min-width: 756px;
  }

  @media (max-width: 1023px) {
    width: 100%;
    padding: 24px 24px 110px;
  }
`;

export const MobWrapper = styled('div')`
  width: 100%;
  min-width: 500px;
  @media (max-width: 1023px) {
    min-width: 0;
    max-width: 784px;
    margin: 0px auto;
  }
`;

export const HeroPanel = styled('div')`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 16px;
  padding: 0 56px 64px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.65) 100%);
  }

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const HeroImage = styled('img')`
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const HeroCaption = styled(Typography)`
  position: relative;
  z-index: 2;
  color: ${({ theme }) => theme.palette.white.main};
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
  max-width: 520px;
`;

export const SupportButton = styled('a')`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  align-self: flex-end;
  gap: 8px;
  flex-shrink: 0;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.white.main};
`;

export const MobileSupportButton = styled('a')`
  position: relative;
  flex-direction: column;
  padding: 32px 0px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};

  @media (min-width: 1023px) {
    display: none;
  }
`;

export const SupportIcon = styled('div')`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.info.main};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;

export const MobileSupportIcon = styled('div')`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;

export const SupportLabel = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
  text-decoration: underline;
  color: inherit;
  white-space: nowrap;
`;

export const AuthPageTitle = styled(Typography)`
  margin-top: 24px;
  font-weight: 700;
  font-size: 40px;
  line-height: 70px;
  white-space: break-spaces;
  @media (max-width: 1023px) {
    font-size: 36px;
    line-height: 35px;
  }
`;

export const AuthSubPageTitle = styled(Typography)`
  font-weight: 400;
  font-size: 21px;
  line-height: 25px;
  margin-bottom: 24px;
  white-space: break-spaces;

  @media (max-width: 1023px) {
    font-size: 21px;
    margin-top: 24px;
    line-height: 25px;
  }
`;
